<template>
	<div class="box">
		<div class="list">
			<div class="title">
				<div class="bak"></div> 本人基本信息
			</div>
			<van-cell-group>
				<van-cell title="姓名" :value="patient.patientName" />
				<van-cell title="身份证号码" :value="patient.idCard" />
				<van-cell title="手机号码" :value="patient.phoneNumber" />
				<van-cell title="填报日期" :value="gettime" />
			</van-cell-group>
		</div>
		<div class="list">
			<div class="title">
				<div class="bak"></div> 本人基本情况
			</div>
			<van-cell-group>
				<van-cell title="身体情况" :required="true">
					<template #label>
						<div class="select">
							<div :class="[form.bodystaus?'itemB':'itemA']" @click="select('bodystaus',0)">正常</div>
							<div :class="[form.bodystaus?'itemA':'itemB']" @click="select('bodystaus',1)">异常</div>
						</div>
						<div v-if="!form.bodystaus" class="checkbox">
							<van-checkbox-group v-model="result" class="vancheckboxgroup">
								<van-checkbox name="1" shape="square" class="vancheckbox">发热</van-checkbox>
								<van-checkbox name="2" shape="square" class="vancheckbox">干呕</van-checkbox>
								<van-checkbox name="3" shape="square" class="vancheckbox">乏力</van-checkbox>
								<van-checkbox name="4" shape="square" class="vancheckbox">鼻塞</van-checkbox>
								<van-checkbox name="5" shape="square" class="vancheckbox">流涕</van-checkbox>
								<van-checkbox name="6" shape="square" class="vancheckbox">咽痛</van-checkbox>
								<van-checkbox name="7" shape="square" class="vancheckbox">肌通</van-checkbox>
								<van-checkbox name="8" shape="square" class="vancheckbox">结膜炎</van-checkbox>
								<van-checkbox name="9" shape="square" class="vancheckbox">腹泻</van-checkbox>
								<van-checkbox name="0" shape="square" class="vancheckbox">嗅（味）觉减退（丧失）</van-checkbox>
							</van-checkbox-group>
						</div>
					</template>
				</van-cell>
				<van-cell title="体温" :required="true" @click="selecttemperature">
					<template #label>
						<div>{{form.temperature?form.temperature:'请选择体温'}}</div>
					</template>
				</van-cell>
				<van-cell title="居住地址" :required="true" @click="selectaddress">
					<template #label>
						<div> {{ form.address ? form.address : '请选择居住地址' }}</div>
					</template>
				</van-cell>
			</van-cell-group>
		</div>

		<div class="list">
			<div class="title">
				<div class="bak"></div> 流行病学史
			</div>
			<van-cell-group>
				<van-cell v-for="(item,index) in list1" :key="index" :title="item.title" :required="true">
					<template #label>
						<div class="select">
							<div class="text"> 本人 </div>
							<div :class="[item.status1?'itemA':'itemB']" @click="selectlist('list1',index,'status1','false')">否</div>
							<div :class="[item.status1?'itemB':'itemA']" @click="selectlist('list1',index,'status1','true')">是</div>
						</div>
						<div class="select">
							<div class="text"> 共同居住者 </div>
							<div :class="[item.status2?'itemA':'itemB']" @click="selectlist('list1',index,'status2','false')">否</div>
							<div :class="[item.status2?'itemB':'itemA']" @click="selectlist('list1',index,'status2','true')">是</div>
						</div>
					</template>
				</van-cell>
			</van-cell-group>
		</div>

		<div class="list">
			<div class="title">
				<div class="bak"></div> 风险人群
			</div>
			<van-cell-group>
				<van-cell v-for="(item,index) in list2" :key="index" :title="item.title" :required="true">
					<template #label>
						<div class="select">
							<div class="text"> 本人 </div>
							<div :class="[item.status1?'itemA':'itemB']" @click="selectlist('list2',index,'status1','false')">否</div>
							<div :class="[item.status1?'itemB':'itemA']" @click="selectlist('list2',index,'status1','true')">是</div>
						</div>
						<div class="select">
							<div class="text"> 共同居住者 </div>
							<div :class="[item.status2?'itemA':'itemB']" @click="selectlist('list2',index,'status2','false')">否</div>
							<div :class="[item.status2?'itemB':'itemA']" @click="selectlist('list2',index,'status2','true')">是</div>
						</div>
					</template>
				</van-cell>
			</van-cell-group>
			<div class="subtitle">本人或共同居住者从事可能接触新冠病毒或新冠病毒感染者相关工作的较高风险人群,主要包括:</div>
			<van-cell-group>
				<van-cell v-for="(item,index) in list3" :key="index" :title="item.title" :required="true">
					<template #label>
						<div class="select">
							<div class="text"> 本人 </div>
							<div :class="[item.status1?'itemA':'itemB']" @click="selectlist('list3',index,'status1','false')">否</div>
							<div :class="[item.status1?'itemB':'itemA']" @click="selectlist('list3',index,'status1','true')">是</div>
						</div>
						<div class="select">
							<div class="text"> 共同居住者 </div>
							<div :class="[item.status2?'itemA':'itemB']" @click="selectlist('list3',index,'status2','false')">否</div>
							<div :class="[item.status2?'itemB':'itemA']" @click="selectlist('list3',index,'status2','true')">是</div>
						</div>
					</template>
				</van-cell>
			</van-cell-group>
		</div>

		<div class="list">
			<div class="title">
				<div class="bak"></div> 新冠疫苗接种情况
			</div>
			<van-cell title="当前接种情况" :required="true">
				<template #label>
					<van-radio-group v-model="vaccination" direction="horizontal" style="margin-top: 10px;">
						<van-radio name="0" shape="square">未接种</van-radio>
						<van-radio name="1" shape="square">接种一针</van-radio>
						<van-radio name="2" shape="square">接种二针</van-radio>
						<van-radio name="3" shape="square">接种三针</van-radio>
					</van-radio-group>
				</template>
			</van-cell>
		</div>

		<div class="promise">
			<div class="promise_title"> <span>*</span> 本人郑重承诺</div>
			<div class="promisegroup">
				<van-radio-group v-model="form.radio">
					<van-radio name="1" shape="square">确认上述情况属实。根据《传染病防治法》及疫情防控要求,不如实提供信息将承担相应法律责任。</van-radio>
				</van-radio-group>
			</div>

		</div>

		<div style="width: 100%;height: 80px;"></div>

		<div class="submit">
			<div :class="submitStatus ? 'submitbunb' : 'submitbun'" @click="submit">提交</div>
		</div>

		<van-popup v-model="temperatureshow" position="bottom">
			<van-picker title="请选择体温" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel" />
		</van-popup>
		<van-popup v-model="addressshow" round position="bottom">
			<van-cascader v-model="form.address" title="请选择所在地区" :options="options" @close="addressshow = false"
				@finish="onFinish" :field-names="fieldNames" />
		</van-popup>
	</div>
</template>

<script>
import { getDefaultPatient, EpRecords } from '@/api/api'
import { Dialog, Toast } from 'vant'
export default {
	props: {

	},
	data () {
		return {
			gettime: '',
			patient: '',
			qData: '',
			submitStatus: false,
			radio: '',
			options: require("../../utils/area.json"),
			fieldNames: {
				text: 'label',
				value: 'value',
				children: 'children',
			},
			temperatureshow: false,
			addressshow: false,
			result: [],
			vaccination: '3',
			columns: [
				{
					values: ['33', '34', '35', '36', '37', '38', '39', '40', '41', '42',],
					defaultIndex: 2,
				},
				{
					values: ['度'],
					defaultIndex: 1,
				},
				{
					values: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',],
					defaultIndex: 1,
				},
			],
			form: {
				bodystaus: false, //身体情况
				temperature: '', //体温
				address: '', //地区
				radio: '',
			},

			list1: [
				{
					title: '14天内有中、高风险地区旅居史',
					status1: false,
					status2: false,
				},
				{
					title: '14天内本人有境外旅居史',
					status1: false,
					status2: false,
				},
				{
					title: '14天内曾接触过来自中、高风险地区的有发热或呼吸',
					status1: false,
					status2: false,
				},
				{
					title: '14天内曾接触过新冠病毒感染者或其密切接触者',
					status1: false,
					status2: false,
				},
				{
					title: '聚集性发病患者(14天内在小范围如家庭、办公室、学校班级等场所,出现2例及以上发热或呼吸道症状的患者)',
					status1: false,
					status2: false,
				},
			],
			list2: [
				{
					title: '流行病学史中所述任一情况人员的共同居住者',
					status1: false,
					status2: false,
				},
			],
			list3: [
				{
					title: '跨境交通工具司乘、保洁、维修等人员,口岸进口物品搬运人员',
					status1: false,
					status2: false,
				},
				{
					title: '集中隔离场所工作人员',
					status1: false,
					status2: false,
				},
				{
					title: '医疗机构发热门诊以及正在启用收治新冠病毒感染者的定点医院、亚定点医院、方舱医院工作人员',
					status1: false,
					status2: false,
				},
				{
					title: '海关、移民管理部门直接接触入境人员和物品的一线',
					status1: false,
					status2: false,
				},
				{
					title: '纳入社区管理的新冠肺炎出院(舱)感染者及同住人',
					status1: false,
					status2: false,
				},
			]
		};
	},
	computed: {},
	created () { },
	mounted () {
		this.qData = this.$route.query.data
		this.getCurrentTime()
		this.getPatientData()
	},
	watch: {
		'form': {
			handler (newName, oldName) {
				let isEmpty = true
				for (let i in this.form) {
					if (String(this.form[i]) == '') {
						isEmpty = false
						break
					}
				}
				this.submitStatus = isEmpty
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		getCurrentTime () {
			//获取当前时间并打印
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
			_this.gettime = yy + '/' + mm + '/' + dd
		},
		getPatientData () {
			getDefaultPatient().then((res) => {
				if (res.code == 200) {
					if (res.data.length != 1) {
						this.patient = ''
					} else {
						this.patient = res.data[0]
					}
				}
			})
		},

		submit () {
			console.log(this.submitStatus)
			if (!this.submitStatus) return

			let sstatus = true
			if (!this.form.bodystaus) sstatus = false


			if (Number(this.form.temperature.slice(0, -2)) >= 37) {
				console.log(this.form.temperature, Number(this.form.temperature.slice(0, -2)) > 37)
				sstatus = false
			}

			for (let i in this.list1) {
				console.log(this.list1[i].status1)
				if (this.list1[i].status1 || this.list1[i].status2) sstatus = false
			}

			for (let i in this.list2) {
				if (this.list2[i].status1 || this.list2[i].status2) sstatus = false
			}

			for (let i in this.list3) {
				if (this.list3[i].status1 || this.list3[i].status2) sstatus = false
			}

			if (this.vaccination == '0') sstatus = false

			let data = {
				patientName: this.patient.patientName,
				documentType: this.patient.documentType,
				idCard: this.patient.idCard,
				phoneNumber: this.patient.phoneNumber,
				abnormal: sstatus ? '0' : '1',
			}
			if (sstatus) {
				EpRecords(data).then(res => {
					if (res.code == 200) {
						this.$router.push({
							name: 'acidpay',
							query: {
								data: this.qData,
							},
						})
					}
				})
			} else {
				Dialog.alert({
					title: '温馨提示',
					message: '声明:流调题目中如果有任何一项“是"选项,则无法完成核酸门诊预约,建议发热门诊就医。',
				}).then(() => {
					EpRecords(data).then(res => { })
				});
			}
		},
		onFinish ({ selectedOptions }) {
			this.addressshow = false;
			this.form.address = selectedOptions.map((option) => option.label).join('/');
		},
		selecttemperature () {
			this.temperatureshow = true
		},
		selectaddress () {
			this.addressshow = true
		},
		onConfirm (value) {
			this.form.temperature = `${value[0]}.${value[2]}°C`
			this.temperatureshow = false
		},
		onCancel () {
			this.temperatureshow = false
		},
		select (type, value) {
			let str = ''
			if (value == 0) {
				str = 'this.form.' + type + ' = true '
			} else {
				str = 'this.form.' + type + ' = false '
			}
			eval(str)
		},
		selectlist (type, index, statusnum, value) {
			let str = 'this.' + type + '[' + index + '].' + statusnum + '=' + value
			eval(str)
		},
	},
	components: {},
};
</script>

<style scoped lang="scss">
.box {
	width: 100%;
	min-height: 100vh;
	background-color: #f7f8fa;
	margin-bottom: 50px;
}

.list {
	margin-bottom: 20px;
}

.title {
	display: flex;
	background-color: #ffffff;
	padding: 10px 0px;
	font-size: 17px;

	.bak {
		width: 5px;
		display: inline-block;
		background-color: rgb(42, 133, 255);
		margin-right: 15px;
	}
}

.select {
	display: flex;
	align-items: center;
	margin-top: 10px;

	.text {
		width: 70px;
		text-align: right;
		margin-right: 20px;
		color: #333333;
		font-size: 14px;
	}

	.itemA {
		font-size: 14px;
		color: rgb(153, 153, 153);
		padding: 3px 35px;
		border: 1px solid rgb(204, 204, 204);
		margin-right: 25px;
		border-radius: 2px;
	}

	.itemB {
		font-size: 14px;
		color: rgb(42, 133, 255);
		padding: 3px 35px;
		border: 1px solid rgb(42, 133, 255);
		margin-right: 25px;
		border-radius: 2px;
		background-color: rgb(245, 248, 255);
	}
}

.checkbox {
	font-size: 16px;
	margin-top: 15px;
	display: flex;

	.vancheckboxgroup {
		display: flex;
		flex-wrap: wrap;

		.vancheckbox {
			min-width: 33%;
			margin-bottom: 15px;
		}
	}
}

.subtitle {
	background-color: #ffffff;
	padding: 5px 10px;
	font-size: 14px;
}

.promise {
	background-color: rgb(255, 246, 220);

	.promise_title {
		padding: 15px 0px 15px 13px;

		span {
			color: #ee0a24;
		}
	}

	.promisegroup {
		padding: 0px 10px 10px 15px;
	}
}

.submit {
	background-color: #ffffff;
	width: 100%;
	height: 80px;
	text-align: center;
	position: fixed;
	bottom: 0;
	display: flex;
	align-items: center;

	.submitbun {
		width: 90%;
		height: 50px;
		line-height: 50px;
		text-align: center;
		margin: auto;
		border: 1px solid rgb(204, 204, 204);
		background-color: rgb(244, 249, 255);
		color: rgb(182, 195, 210);
		border-radius: 4px;
	}

	.submitbunb {
		width: 90%;
		height: 50px;
		line-height: 50px;
		text-align: center;
		margin: auto;
		border: 1px solid rgb(42, 133, 225);
		background-color: rgb(42, 133, 225);
		color: #ffffff;
		border-radius: 4px;
	}
}
</style>
